import { render } from "./404.vue?vue&type=template&id=721c1d6f"
const script = {}

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__